import { IComponentOptions, IController } from "angular";
import { IEnrichedEmployee } from "@gtmhub/employees/models/models";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { formatAttainmentProgressValue } from "@gtmhub/okrs/metrics/utils";
import { IPersonalBestStats, ProfileScreenName, ProfileService } from "@gtmhub/profile";
import { IEnrichedTeam } from "@gtmhub/teams";
import { GroupDetailsSidebarConfig } from "../group-details-sidebar/group-details-sidebar.component";
import { GroupDetailsSidebarService } from "../group-details-sidebar/group-details-sidebar.service";

export class PersonalBestSectionCtrl implements IController {
  personalBest: IPersonalBestStats;
  target: IEnrichedEmployee | IEnrichedTeam;
  indicators: { loading: boolean };
  screenName: ProfileScreenName;
  formatAttainmentProgressValue: (progress: number) => number;
  static $inject = ["ProfileService", "UIErrorHandlingService", "GroupDetailsSidebarService"];

  get targetName(): string {
    if (this.target.type === "user") {
      return this.target.firstName;
    }

    return this.target.name;
  }

  constructor(
    private profileService: ProfileService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private groupDetailsSidebarService: GroupDetailsSidebarService
  ) {
    this.formatAttainmentProgressValue = formatAttainmentProgressValue;
  }

  $onInit(): void {
    this.screenName = this.target.type === "user" ? "employee profile" : "team profile";

    this.indicators = {
      loading: true,
    };
    this.profileService.getPersonalBestStats(this.target.type, this.target.id).then(
      (stats) => {
        this.personalBest = stats;
        this.indicators.loading = false;
      },
      (error) => {
        this.indicators.loading = false;
        this.uiErrorHandlingService.handleModal(error);
      }
    );
  }

  openBestSession(): void {
    const config: GroupDetailsSidebarConfig = { label: { icon: "session", key: this.personalBest.bestSession.sessionName }, group: { type: "goals", icon: "goal" } };
    const filter = {
      $and: [{ sessionId: { $in: [this.personalBest.bestSession.sessionId] } }],
    };
    this.groupDetailsSidebarService.open({ config, filter, screenName: this.screenName });
  }
}

export const PersonalBestSectionComponent: IComponentOptions = {
  bindings: {
    target: "<",
  },
  controller: PersonalBestSectionCtrl,
  template: require("./personal-best-section.component.html"),
};
